var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{staticClass:"my-0",attrs:{"color":"primary","hide-details":"","label":_vm.label,"true-value":true,"false-value":false,"value":_vm.value},on:{"change":_vm.changed}})}
var staticRenderFns = []

export { render, staticRenderFns }